import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardHeader, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";

import WhatsAppConfig from "./WhatsAppConfig";
import EmailConfig from "./EmailConfig";

const tabLabels = [
  { label: "WhatsApp", icon: <WhatsAppIcon /> },
  { label: "Email", icon: <EmailIcon /> },
];

const ORANGE = "#F25D21";
const ORANGE_LIGHT = "#fff3e0";

const ERCSConfiguration = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        p: 3,
        borderRadius: 0,
      }}
    >
      <Card
        elevation={0}
        sx={{
          mb: 3,
          border: "1px solid #ffe0b2",
          backgroundColor: "#fff",
        }}
      >
        <CardHeader
          avatar={<SettingsIcon sx={{ color: ORANGE }} fontWeight={100} style={{fontFamily:'karbon' , color:'#666666'}} />}
          title={
            <Typography variant="h5" fontWeight={100} style={{fontFamily:'karbon' , color:'#666666'}}>
              ERCS Configuration
            </Typography>
          }
          subheader={
            <Typography style={{fontFamily:'karbon' , color:'#666666'}} fontWeight={100}>
              Manage your communication system settings
            </Typography>
          }
        />
      </Card>

      <Box
        sx={{
          border: 1,
          borderColor: "#ffe0b2",
          borderRadius: 1,
          bgcolor: "#fff",
        }}
      >
        <Tabs
          value={selectedTab}
          onChange={(e, v) => setSelectedTab(v)}
          aria-label="ERCS Configuration Tabs"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: ORANGE,
            },
            "& .Mui-selected": {
              color: ORANGE + " !important",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "1rem",
              minHeight: 64,
              color: "#a6a4a4",
              "&.Mui-selected": {
                color: ORANGE,
              },
            },
          }}
        >
          {tabLabels.map((tab, index) => (
            <Tab
              key={index}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              sx={{ gap: 1 }}
              style={{fontFamily:'karbon' , color:'#666666' , fontWeight:100}}
              
            />
          ))}
        </Tabs>

        <Box sx={{ p: 3, background: "#fff" }}>
          {selectedTab === 0 && <WhatsAppConfig />}
          {selectedTab === 1 && <EmailConfig />}
        </Box>
      </Box>
    </Box>
  );
};

export default ERCSConfiguration;
